import React, { useState, useEffect, useRef } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import UserIcon from "@material-ui/icons/Person";
import ShoppingCartOutlined from "@material-ui/icons/ShoppingCartOutlined";
import Cookies from "js-cookie";
import ModalAccion from "../Modales/ModalAccion.jsx";
import Globales from "utils/Globales";
import CustomDropdown from "components/CustomDropdown/CustomDropdown.jsx";
import Button from "components/CustomButtons/Button.jsx";
import headerLinksStyle from "assets/jss/material-kit-pro-react/components/headerLinksStyle.jsx";
import LoginButton from "../../Aunt0/loginbutton.jsx";
import LogoutButton from "../../Aunt0/logoutbutton.jsx";
import ModalNotifiacion from "./ModalNotifiacion.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import { CircularProgress, Badge } from "@material-ui/core";
import { authApi } from "api/auth/index.js";
import { useUserStore } from "stores/userStore.js";

function HeaderLinks(props) {
	const { classes, dropdownHoverColor } = props;
	const location = useLocation();
	const { isAuthenticated, user, isLoading, logout } = useAuth0();
	const [auth, setAuth] = useState(null);
	const [liveDemo, setLiveDemo] = useState(false);
	const [cargando, setCargando] = useState(true);
	const { userState, setUser, clearUser } = useUserStore();

	const [colorNotificacion, setColorNotificacion] = useState("success");
	const [mensaje, setMensaje] = useState("");
	const [Titulo, setTitulo] = useState("");
	const [br, setBr] = useState(false);
	const [brModal, setBrModal] = useState(false);
	const [necesitaValidacion, setNecesitaValidacion] = useState(false);
	const validandoRef = useRef(false); // Para evitar validaciones duplicadas
	const modalMostradoRef = useRef(false); // Para evitar mostrar modal duplicado
	const correoEnviadoRef = useRef(false); // Para evitar envío duplicado del correo

	const showNotification = (mensaje, color) => {
		setBr(true);
		setMensaje(mensaje);
		setColorNotificacion(color);
		setTimeout(
			function() {
				setBr(false);
			}.bind(this),
			5000
		);
	};
	const showNotificationModal = (Titulo, mensaje, color) => {
		setBrModal(true);
		setTitulo(Titulo);
		setMensaje(mensaje);
		setColorNotificacion(color);
	};

	useEffect(() => {
		// logout({ logoutParams: { returnTo: window.location.origin } })
		let mensaje = Cookies.get("Mensaje");
		if (mensaje != null) {
			let colorMensaje = Cookies.get("ColorMensaje");
			showNotification(mensaje, colorMensaje);
			Cookies.remove("Mensaje");
		}

		if (userState && userState.SocialToken) {
			Login(userState.SocialToken);
		}

		// Escuchar evento de sesión expirada
		const handleSessionExpired = (event) => {
			const message =
				event.detail?.message ||
				"Tu sesión ha expirado. Por favor, inicia sesión nuevamente.";
			showNotification(message, "warning");
		};

		window.addEventListener("sessionExpired", handleSessionExpired);

		// Limpiar listener al desmontar
		return () => {
			window.removeEventListener("sessionExpired", handleSessionExpired);
		};
	}, []);

	const irPerfil = () => {
		window.location.href = "/Perfil";
		window.location.reload();
	};

	const eventoModal = (e) => {
		if (!e) {
			setLiveDemo(false);
			return;
		}
		cerrarSesion();
	};

	useEffect(() => {
		// No hacer validación si estamos en la ruta de verificación de acceso o en login
		// LoginAuth0.jsx ya maneja el envío de correo en la ruta /login
		if (
			location.pathname === "/ValidarAcceso" ||
			location.pathname === "/login"
		) {
			setCargando(false);
			validandoRef.current = false;
			modalMostradoRef.current = false;
			correoEnviadoRef.current = false;
			return;
		}

		// Si Auth0 aún está cargando, mantener el estado de carga
		if (isLoading) {
			return;
		}

		// Si no está autenticado, dejar de cargar y resetear refs
		if (!isAuthenticated) {
			setCargando(false);
			validandoRef.current = false;
			modalMostradoRef.current = false;
			correoEnviadoRef.current = false;
			return;
		}

		// Si está autenticado pero no hay usuario aún, esperar
		if (!user) {
			return;
		}

		// Si el correo no está verificado según Auth0, validar primero para confirmar
		if (
			isAuthenticated &&
			user.email_verified === false &&
			!validandoRef.current
		) {
			validandoRef.current = true;
			ValidarUsuario(user);
			return;
		}

		// Si el correo está verificado (o undefined/null, asumir verificado), validar usuario (refrescar sesión)
		// Solo validar si no estamos validando ya
		if (
			!validandoRef.current &&
			isAuthenticated &&
			user &&
			(user.email_verified === true || user.email_verified === undefined)
		) {
			validandoRef.current = true;
			ValidarUsuario(user);
		} else if (!validandoRef.current) {
			// Si no está validando, dejar de cargar
			setCargando(false);
		}
	}, [isAuthenticated, user, isLoading, location.pathname]);

	const Login = async (socialToken) => {
		if (socialToken == null) {
			return;
		}
		setCargando(true);

		let respuesta = await authApi.Auth({
			socialToken,
		});

		if (!respuesta.success) {
			logout();
			clearUser();
			setlogeado(false);
			setCargando(false);
			showNotification(respuesta.message, "warning");
		} else {
			// Actualiza el estado con la respuesta del servidor
			var sesion = {
				id: respuesta.data.user._id,
				SocialToken: respuesta.data.user.RedSocial,
				Basket: respuesta.data.basket,
				ShoppingCart: respuesta.data.user.ListaCarrito,
				User: respuesta.data.user.Usuario,
				Name: respuesta.data.user.Nombre,
				Email: respuesta.data.user.Correo,
				Phone: respuesta.data.user.Telefono,
				Type: respuesta.data.user.TipoUsuario,
				Token: respuesta.data.Token,
				Refresh: false,
			};
			setCargando(false);
			setUser(sesion);
			localStorage.setItem("idUser", respuesta.data.user._id);
			if (Cookies.get("idDiseno") != null) {
				Cookies.set("login", 1);
			}
		}
		setCargando(false);
	};

	const ValidarUsuario = async (user) => {
		try {
			let repuesta = await authApi.ValidateAcount({
				socialToken: user.sub,
				Email: user.email,
				name: user.name,
			});

			// Siempre tendremos contenido de la respuesta, incluso en caso de error
			if (repuesta.success) {
				setNecesitaValidacion(false);
				validandoRef.current = false;
				Login(user.sub);
			} else {
				// Verificar tanto en data como en errors (por compatibilidad)
				const needsValidation =
					(repuesta.data && repuesta.data.needsValidation) ||
					(repuesta.errors && repuesta.errors.needsValidation);

				// Si el mensaje es sobre validar correo, asumir que necesita validación
				const mensajeEsValidacion =
					repuesta.message &&
					repuesta.message.toLowerCase().includes("valide tu correo");

				// IMPORTANTE: NO mostrar modal si el email ya está verificado en Auth0
				// El endpoint verify-email ya debería haber actualizado Pendiente: false
				// TAMBIÉN: No mostrar si ya se mostró antes (usando localStorage)
				const modalYaMostrado = localStorage.getItem(`modalVerificacion_${user.sub}`);
				
				if ((needsValidation || mensajeEsValidacion) && user.email_verified !== true && !modalYaMostrado) {
					// Solo mostrar modal y enviar correo si no se ha hecho ya
					if (!modalMostradoRef.current && !correoEnviadoRef.current) {
						correoEnviadoRef.current = true;
						modalMostradoRef.current = true;
						
						// Marcar que ya se mostró el modal para este usuario
						localStorage.setItem(`modalVerificacion_${user.sub}`, "true");

						setNecesitaValidacion(true);

						// Auth0 ya envió el correo automáticamente al registrarse
						// No necesitamos enviar correo desde el frontend
						// El correo fue enviado automáticamente por Auth0 cuando el usuario se registró

						setBrModal(true);
					}
					// NO mostrar notificación, solo el modal
				} else if (needsValidation || mensajeEsValidacion) {
					// Email está verificado en Auth0 pero aún Pendiente: true en BD
					// O ya se mostró el modal antes
					// No mostrar modal, solo loguear
					console.log("Email verificado en Auth0 o modal ya mostrado, no se muestra modal en HeaderLinks");
					// Intentar verificar automáticamente
					try {
						await fetch(`${Globales.Url}ecommerce/auth/verify-email`, {
							method: "POST",
							headers: {
								"Content-Type": "application/json",
							},
							body: JSON.stringify({
								auth0UserId: user.sub,
							}),
						});
					} catch (err) {
						console.log("Error al verificar email automáticamente en HeaderLinks:", err);
					}
				} else {
					// Otro tipo de error, mostrar notificación
					showNotification(
						repuesta.message || "Error en la validación",
						"warning"
					);
				}
				validandoRef.current = false;
			}
		} catch (error) {
			// Este bloque solo se ejecutará si hay un error de red u otro error no relacionado con la respuesta
			console.error("Error de conexión:", error);
			showNotification(error.message || "Error de conexión", "warning");
			validandoRef.current = false;
		}
		setCargando(false);
	};


	const cerrarSesion = () => {
		setLiveDemo(false);
		clearUser();
	};

	const eventClickNotifiacion = () => {
		setBrModal(false);
		if (!userState.id) {
			// Redirigir a la página principal
			logout({ logoutParams: { returnTo: window.location.origin + "/login" } });
		} else {
			window.location.reload();
		}
	};

	const cantidadCarrito = userState.id ? userState.Basket : 0;

	return (
		<div style={{ position: "absolute", right: "0" }}>
			<List
				className={classes.list + " " + classes.mlAuto}
				style={{ fontSize: "12px" }}
			>
				<ListItem className={classes.listItem}>
					<Link
						to="/"
						className={classes.dropdownLink}
						style={{ fontSize: "14px" }}
					>
						INICIO
					</Link>
				</ListItem>
				<ListItem className={classes.listItem}>
					<Link
						to="/SeleccionaTuDiseño"
						className={classes.dropdownLink}
						style={{ fontSize: "14px" }}
					>
						DISEÑADOR
					</Link>
				</ListItem>
				{/* <ListItem className={classes.listItem}>
					<Link to="/Artistas" className={classes.dropdownLink}>
						ARTISTAS
					</Link>
				</ListItem> */}
				{cargando ? (
					<ListItem className={classes.listItem}>
						<CircularProgress
							size={35}
							thickness={5}
							style={{ color: "white" }}
						/>
					</ListItem>
				) : userState.id ? (
					<ListItem className={classes.listItem}>
						<CustomDropdown
							noLiPadding
							navDropdown
							buttonText={
								userState.Name && typeof userState.Name === "string"
									? userState.Name.split(" ")[0]
									: "Usuario"
							}
							buttonProps={{
								style: {
									border: "1px solid #828282",
									borderRadius: 5,
									fontSize: 14,
									height: "40px",
								},
								color: "transparent",
							}}
							dropdownList={[
								<Link
									to="/Perfil"
									className={classes.dropdownLink}
									style={{ fontSize: "14px" }}
								>
									PERFIL
								</Link>,
								<LogoutButton />,
							]}
						/>
					</ListItem>
				) : (
					<ListItem style={{ width: "135px" }} className={classes.listItem}>
						<LoginButton />
					</ListItem>
				)}
				{userState.id && (
					<ListItem>
						<Link className={classes.dropdownLink} to="/carrito">
							{window.innerWidth < 960 ? (
								"Carrito " + "(" + cantidadCarrito + ")"
							) : (
								<Badge badgeContent={cantidadCarrito}>
									<div style={{ backgroundColor: "212121", color: "#fefefe" }}>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="25"
											height="25"
											fill="currentColor"
											class="bi bi-cart3"
											viewBox="0 0 16 16"
										>
											<path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .49.598l-1 5a.5.5 0 0 1-.465.401l-9.397.472L4.415 11H13a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5M3.102 4l.84 4.479 9.144-.459L13.89 4zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2m7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2" />
										</svg>
									</div>
								</Badge>
							)}
						</Link>
					</ListItem>
				)}
			</List>
			<div id="">
				<Snackbar
					place="tr"
					color={colorNotificacion}
					message={mensaje}
					open={br}
					closeNotification={() => setBr(false)}
					close
				/>
				<ModalNotifiacion
					Show={brModal}
					eventClick={eventClickNotifiacion}
					mensaje={mensaje}
					color={colorNotificacion}
					titulo={Titulo}
				/>
				<ModalAccion
					Titulo="Cerrar Sesión"
					body={"¿Seguro que deseas cerrar sesión?"}
					liveDemo={liveDemo}
					eventClick={eventoModal}
				/>
			</div>
		</div>
	);
}

HeaderLinks.defaultProps = {
	hoverColor: "primary",
};

HeaderLinks.propTypes = {
	dropdownHoverColor: PropTypes.oneOf([
		"dark",
		"primary",
		"info",
		"success",
		"warning",
		"danger",
		"rose",
	]),
};

export default withStyles(headerLinksStyle)(HeaderLinks);
